// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gp {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.gp .gp-flat {\n    margin: 0 auto;\n    padding: 10px 0 0!important;\n    box-shadow: none!important;\n    transform: none!important;\n}", ""]);
// Exports
module.exports = exports;
